import { PageHero } from "../components/site/PageHero";
import { ContactForm } from "../components/site/ContactForm";
import { ContactDetails } from "../components/site/ContactDetails";
import { Eyebrow, Reveal } from "../components/site/Motion";
import { usePageMeta } from "../components/site/SmoothScroll";
import { FAQ, ProseSection } from "../components/site/SeoContent";
import { CONTACT_PROSE, CONTACT_FAQ } from "../lib/seoContent";
import { IMAGES, MAP_EMBED, MAP_LINK, HOURS } from "../lib/site";

export default function Contact() {
  usePageMeta(
    "Contact a Psychic & Astrologer in Calgary | Astrologer & Spiritual Healers",
    "Contact Astrologer & Spiritual Healers in Calgary, Alberta by phone, WhatsApp or email. View business hours and send us a message."
  );
  return (
    <main data-testid="contact-page">
      <PageHero
        testId="contact-hero"
        eyebrow="Contact"
        image={IMAGES.hero}
        lines={[{ text: "Let's begin" }, { text: "the conversation", className: "italic gold-text" }]}
        intro="Call, send a WhatsApp message or write to us below. We aim to respond to every enquiry as soon as possible."
      />
      <section className="px-5 pb-20 sm:px-8 lg:px-12">
        <div className="mx-auto grid max-w-[1400px] gap-12 lg:grid-cols-12">
          <Reveal className="lg:col-span-5">
            <Eyebrow>Reach Us</Eyebrow>
            <div className="mt-4"><ContactDetails /></div>
          </Reveal>
          <Reveal delay={0.1} className="border border-[#D4AF37]/20 bg-[#0E081D]/80 p-6 sm:p-10 lg:col-span-7">
            <h2 className="font-display text-3xl text-white sm:text-4xl">Send a message</h2>
            <p className="mb-8 mt-2 text-slate-300">For appointments, please use the booking page — for everything else, write here.</p>
            <ContactForm />
          </Reveal>
        </div>
      </section>
      <section data-testid="contact-map-section" className="px-5 pb-24 sm:px-8 sm:pb-32 lg:px-12">
        <div className="relative mx-auto max-w-[1400px] overflow-hidden border border-[#D4AF37]/25">
          <iframe
            title="Map of Calgary, Alberta"
            src={MAP_EMBED}
            data-testid="contact-map"
            className="h-[380px] w-full sm:h-[480px]"
            style={{ filter: "invert(92%) hue-rotate(200deg) saturate(0.6) brightness(0.9)" }}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
          <div className="relative border-t border-[#D4AF37]/25 bg-[#0E081D] p-6 sm:absolute sm:bottom-6 sm:left-6 sm:max-w-xs sm:border sm:bg-[#0E081D]/90 sm:backdrop-blur-xl">
            <p className="font-cinzel text-[11px] tracking-[0.3em] text-[#D4AF37]">OUR STUDIO</p>
            <p className="font-display mt-2 text-2xl text-white">Calgary, Alberta</p>
            <a href={MAP_LINK} target="_blank" rel="noopener noreferrer" data-testid="map-directions-link" className="text-sm text-[#D4AF37] hover:text-[#F3E5AB]">Get directions →</a>
            <div className="mt-4 space-y-1 text-sm text-slate-300">
              {HOURS.map((h) => <p key={h.day}>{h.day}: {h.time}</p>)}
            </div>
          </div>
        </div>
      </section>
      <ProseSection testId="contact-prose" eyebrow="Visit or Call" title="Here for you, day and night" paragraphs={CONTACT_PROSE} />
      <FAQ testId="contact-faq" title="Contact questions" items={CONTACT_FAQ} />
    </main>
  );
}
